import { logError } from '@zg-rentals/log-error';

const PX_BLOCKED_HEADER = 'x-px-blocked';

type HttpFailureInfo = {
  method: string;
  url: string;
  status?: number;
  latencyMs?: number;
  headers?: Headers;
};

/**
 * `@zg-rentals/http-client`'s built-in request logging (traceparent/eid/px-blocked context)
 * only runs from its `beforeError` hook, which fires solely when the client throws an
 * `HTTPError` — the default `throwHttpErrors: true` behavior. Every client built in this app
 * sets `throwHttpErrors: false` so it can inspect the raw response/status itself (for proxy
 * passthrough and envelope-error detection), which means that hook never runs. Call this at
 * each failure point instead so failed upstream calls stay visible in Splunk/Dragnet. Header-confirmed
 * PerimeterX blocks are counted by `@zg-rentals/http-client` and intentionally excluded from generic errors.
 */
export function logHttpRequestFailure(
  error: unknown,
  { method, url, status, latencyMs, headers }: HttpFailureInfo,
): void {
  if (headers?.get(PX_BLOCKED_HEADER)) {
    return;
  }

  logError({
    error,
    errorType: 'HTTPError',
    context: {
      url,
      method,
      status,
      latencyMs,
      traceparent: headers?.get('traceparent') ?? undefined,
      eid: headers?.get('x-eid') ?? undefined,
      xPxBlocked: headers?.get('x-px-blocked') ?? undefined,
    },
    httpRequest: { method, url },
  });
}
